module.exports = __webpack_public_path__ + "static/media/semiTractorWithTrailer_black.502455f2.svg";